import React from 'react';
import { StyledPrimaryArrow, StyledRound, StyledSecondaryArrow } from './styled';

export interface ISliderArrowProps extends React.HTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode;
  direction: 'next' | 'prev';
  disabled?: boolean;
}

const SliderArrow:React.FC<ISliderArrowProps> = (props) => {
  return (
    <StyledRound
      data-direction={props.direction}
      {...props}
    >
      <StyledPrimaryArrow />
      <StyledSecondaryArrow />
    </StyledRound>
  );
}

export default SliderArrow;
